import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export const conditionallyRequiredValidator = (formControl: AbstractControl) => {
	if (!formControl.parent) {
		return null;
	}

	const checked = formControl.parent.parent.get('checked').value;
	const subscribed = formControl.parent.get('subscribed').value;

	if (checked || subscribed) {
		return Validators.required(formControl);
	}
	return null;
};

export const conditionalLimit = (type: string, limitValue: number): ValidatorFn => {
	return (formControl: AbstractControl): { [key: string]: boolean } | null => {
		if (!formControl.parent) {
			return null;
		}

		const checked = formControl.parent.parent.get('checked').value;
		const subscribed = formControl.parent.get('subscribed').value;

		const value = formControl.value;
		if (checked || subscribed) {
			switch (type) {
				case 'min':
					return value < limitValue ? { min: true } : null;
				case 'max':
					return value > limitValue ? { max: true } : null;
				default:
					return null;
			}
		}
	};
};

export const conditionalValidator = (): ValidatorFn => {
	return (formControl: AbstractControl): ValidationErrors => {
		if (!formControl.parent) {
			return null;
		}

		const checked = formControl.parent.parent.get('checked').value;
		const subscribed = formControl.parent.get('subscribed').value;

		if (checked || subscribed) {
			return Validators.required(formControl);
		}
		return null;
	};
};

export const duplicateName = (names: string[]): ValidatorFn => {
	return (control: AbstractControl): { [key: string]: boolean } | null => {
		const setIndex = names.findIndex((name) => name.toLowerCase() === control.value.toLowerCase().trim());
		return setIndex > 0 ? { duplicateName: true } : null;
	};
};

export function forbiddenNameValidator(nameRe: RegExp): ValidatorFn {
	return (control: AbstractControl): ValidationErrors => {
		const forbidden = nameRe.test(control.value);
		return forbidden ? { forbiddenName: { value: control.value } } : null;
	};
}

export const emptyEmailList = (): ValidatorFn => {
	return (control: AbstractControl): ValidationErrors => {
		const emailsLength = control.get('emails').value.length;
		const subscribed = control.get('subscribed').value;
		if (subscribed && !emailsLength) {
			return { emptyEmailList: true };
		}
		return null;
	};
};
